import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FacetFilter, SearchEvent } from '../../../shared/models/search.model';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-partners-search-query',
  templateUrl: './partners-search-query.component.html',
  styleUrls: ['./partners-search-query.component.scss'],
  standalone: false,
})
export class PartnersSearchQueryComponent {
  queryForm: UntypedFormGroup = this.formBuilder.group({
    searchTxt: [''],
  });

  @Input()
    facetFilters: FacetFilter[] = [];

  @Output()
    searchChange = new EventEmitter<SearchEvent>();

  constructor(private formBuilder: UntypedFormBuilder) {}

  search(): void {
    this.searchChange.emit({ q: this.queryForm.value.searchTxt, fieldFilters: [], facetFilters: this.facetFilters });
  }

  removeFacetFilter(index: number): void {
    this.facetFilters.splice(index, 1);
    this.search();
  }

  removeFacetFilters(): void {
    this.facetFilters = [];
    this.search();
  }
}
